import { render, staticRenderFns } from "./statistical_configuration.vue?vue&type=template&id=6879ac6e&scoped=true&"
import script from "./statistical_configuration.vue?vue&type=script&lang=js&"
export * from "./statistical_configuration.vue?vue&type=script&lang=js&"
import style0 from "./statistical_configuration.vue?vue&type=style&index=0&id=6879ac6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879ac6e",
  null
  
)

export default component.exports